module.exports = __webpack_public_path__ + "static/media/equality.f7230143.jpg";